import { createContext } from "react";
import type { INavigationNotificationsContext } from "./navigation-notifications-context.types";

export const defaultContext: INavigationNotificationsContext = {
    notificationCount: 0,
    notificationMap: {},
};

export default createContext<INavigationNotificationsContext>(defaultContext);
